var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M24 12c6.468 0 12.34 3.81 17.612 11.431a1 1 0 01.07 1.02l-.07.118-.293.42C36.12 32.328 30.349 36 24 36c-6.468 0-12.34-3.81-17.612-11.431a1 1 0 01-.07-1.02l.07-.118.293-.42C11.88 15.672 17.651 12 24 12zm0 4a8 8 0 100 16 8 8 0 000-16zm0 3a5 5 0 110 10 5 5 0 010-10z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
